import PropTypes from 'prop-types';
import styles from './index.styl';
import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';

function Counter({ activeIndex, totalIndex, theme }) {
  const {
    controls: {
      counter: counterStyles,
    },
  } = theme;
  return (
    <div className={styles.counter}>
      <style jsx>{`
        .${styles.counter}
          font ${counterStyles.font}
      `}</style>
      {activeIndex + 1} / {totalIndex}
    </div>
  );
}

Counter.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  totalIndex: PropTypes.number.isRequired,
  theme: themePropTypes(`
    {
      controls: {
        counter: {
          font
        }
      },
    }
  `),
};

export default withTheme(Counter);
